import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import { logMethod } from "kwikid-toolkit";
import { KwikUIButtonLiveLocationPermissionService } from "./button-live-location.permission.service";

@Component({
  selector: "kwikui-button-live-location",
  templateUrl: "./button-live-location.component.html",
  styleUrls: ["./button-live-location.component.scss"]
})
export class KwikUIButtonLiveLocationComponent implements OnInit {
  @Input() liveLocationStatus:
    | "default"
    | "loading"
    | "retry"
    | "success"
    | "failed" = "default";

  @Input() class = "tui-space_right-3 tui-space_bottom-3";

  @Input() disabled = false;

  @Input() id = "";

  @Input() label = "Button";

  @Input() shape: null | "square" | "rounded" = null;

  @Input() showLoader = false;

  @Input() size: "xs" | "s" | "m" | "l" | "xl" = "m";

  @Input() styles = "";

  @Input() isShowLatLongCaptureTimestamp = "";

  @Output() onClick = new EventEmitter<any>();

  @Output() onLocationPermission: EventEmitter<any> = new EventEmitter<any>();

  isShowApiTimerMessage = false;

  icon = "";

  iconRight = "tuiIconRadioLarge";

  constructor(
    public liveLocationPermissionService: KwikUIButtonLiveLocationPermissionService
  ) {}

  ngOnInit(): void {
    this.handleLiveLocationStatus(this.liveLocationStatus);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const hasKey = (object: any, key: string): boolean => {
      return object.hasOwnProperty(key);
    };
    const verifyChange = (key: string) => {
      return hasKey(changes, key) && !changes[key].firstChange;
    };
    if (verifyChange("liveLocationStatus")) {
      this.handleLiveLocationStatus(changes.liveLocationStatus.currentValue);
    }
    if (verifyChange("disabled")) {
      if (this.liveLocationStatus === "default") {
        this.disabled = changes.disabled.currentValue;
      } else if (this.liveLocationStatus === "loading") {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    }
  }

  ngOnDestroy(): void {}

  handleLiveLocationStatus(liveLocationStatus: string): void {
    switch (liveLocationStatus) {
      case "default":
        this.liveLocationStatus = "default";
        this.icon = "";
        this.iconRight = "tuiIconRadioLarge";
        this.disabled = this.disabled;
        this.showLoader = false;
        break;
      case "loading":
        this.liveLocationStatus = "loading";
        this.icon = "";
        this.iconRight = "";
        this.disabled = true;
        this.showLoader = true;
        break;
      case "success":
        this.liveLocationStatus = "success";
        this.icon = "";
        this.iconRight = "tuiIconCheck";
        this.disabled = false;
        this.showLoader = false;
        break;
      case "failed":
        this.liveLocationStatus = "failed";
        this.icon = "";
        this.iconRight = "tuiIconClose";
        this.disabled = false;
        this.showLoader = false;
        break;
      default:
        break;
    }
  }

  handleOnClick(e: any) {
    if (
      this.liveLocationStatus === "default" ||
      this.liveLocationStatus === "retry"
    ) {
      this.liveLocationPermissionService.askForPermission().then(
        (resolve) => {
          this.liveLocationPermissionService.getLocation().then(
            (resolve) => {
              this.onClick.emit({
                event: e,
                key: this.id,
                liveLocation: resolve
              });
            },
            (reject) => {
              this.onLocationPermission.emit({
                event: e,
                key: this.id,
                permission: false
              });
            }
          );
        },
        (reject) => {
          this.onLocationPermission.emit({
            event: e,
            key: this.id,
            permission: false
          });
        }
      );
    }
  }
}
